import React from 'react';
import { Home } from './components/home';

export const App = (): JSX.Element => {
    return <Home />;
};
